'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSendNewTypicalResponseTimeMessage = undefined;

var _hasBotMessages = require('conversations-schema/thread-history/operators/hasBotMessages');

var _hasTypicalResponseTimeMessageFromCurrentSession = require('./hasTypicalResponseTimeMessageFromCurrentSession');

var _enoughTimeHasPassedForNewAutomatedChatMessage = require('./enoughTimeHasPassedForNewAutomatedChatMessage');

var canSendNewTypicalResponseTimeMessage = exports.canSendNewTypicalResponseTimeMessage = function canSendNewTypicalResponseTimeMessage(thread) {
  return !(0, _hasBotMessages.hasBotMessages)(thread) && (!(0, _hasTypicalResponseTimeMessageFromCurrentSession.hasTypicalResponseTimeMessageFromCurrentSession)(thread) || (0, _enoughTimeHasPassedForNewAutomatedChatMessage.enoughTimeHasPassedForNewAutomatedChatMessage)(thread));
};